export const translations = {
    sq: {
        login: "Hyrje", logout: "Dalje", email: "Email", password: "Fjalëkalim",
        nipt_label: "NIPT (Username)", staff_login: "Hyrje Stafi", client_login: "Portal Klienti",
        login_btn: "Hyrë", login_subtitle: "Sistemi GPS CRM",
        dashboard: "Paneli", clients: "Klientët", devices: "Pajisjet",
        vehicles: "Automjetet", subscriptions: "Abonimet", payments: "Pagesat",
        alerts: "Alarmet", users: "Përdoruesit", settings: "Cilësimet",
        invoices: "Faturat",
        total_clients: "Klientë Total", active_devices: "Pajisje Aktive",
        unpaid_devices: "Pajisje Pa Pagesë", monthly_revenue: "Të Ardhura Mujore",
        expiring_soon: "Skadojnë Shpejt", recent_payments: "Pagesat e Fundit",
        active: "Aktiv", inactive: "Jo Aktiv", debtor: "Borxhli",
        stock: "Stok", pending: "Në Pritje", expired: "I Skaduar",
        add: "Shto", edit: "Modifiko", delete: "Fshi", save: "Ruaj",
        cancel: "Anulo", search: "Kërko", filter: "Filtro",
        transfer: "Transfero", view: "Shiko", generate_pdf: "Gjenero PDF",
        register_payment: "Regjistro Pagesën", add_invoice: "Krijo Faturë",
        client_name: "Emri i Klientit", company: "Kompania",
        phone: "Telefoni", address: "Adresa", type: "Lloji",
        business: "Biznes", individual: "Individual",
        imei: "IMEI", model: "Modeli", device_status: "Statusi",
        client: "Klienti", no_client: "Pa Klient",
        plate: "Targa", driver: "Shoferi", linked_device: "Pajisja",
        plan: "Plani", monthly: "Mujor", yearly: "Vjetor",
        start_date: "Data Fillimit", end_date: "Data Skadimit", price: "Çmimi",
        amount: "Shuma", currency: "Monedha", payment_date: "Data Pagesës",
        method: "Mënyra", cash: "Cash", bank_transfer: "Transfer Bankar", card: "Kartë",
        reference: "Referenca", notes: "Shënime",
        expiring_subscriptions: "Abonime Skadojnë", expired_subscriptions: "Abonime të Skaduara",
        debtor_clients: "Klientë Borxhli", stock_devices: "Pajisje në Stok",
        no_data: "Nuk ka të dhëna", loading: "Duke ngarkuar...",
        success: "U krye me sukses", error: "Ndodhi një gabim",
        confirm_delete: "A jeni i sigurt? Ky veprim nuk mund të kthehet.",
        invoice_number: "Nr. Faturës", issue_date: "Data Lëshimit", due_date: "Afati Pagesës",
        subtotal: "Nëntotali", tax: "TVSH", total: "Totali",
        all_statuses: "Të gjitha", name: "Emri", role: "Roli", status: "Statusi",
        history: "Historiku", transfer_device: "Transfero Pajisjen",
        from_client: "Nga Klienti", to_client: "Tek Klienti", action: "Veprimi",
        date: "Data", assigned: "Caktuar", transferred: "Transferuar", unassigned: "Hequr",
        description: "Përshkrimi", quantity: "Sasia", unit_price: "Çmimi/njësi",
        auto_renew: "Rinovim Automatik", revenue: "Të Ardhura",
        monthly_chart: "Të Ardhura Mujore (6 muajt e fundit)",
        search_placeholder: "Kërko sipas IMEI, emrit, targës...",
        results_clients: "Klientë", results_devices: "Pajisje", results_vehicles: "Automjete",
        no_results: "Nuk u gjetën rezultate",
        alert_count: "alarme aktive",
        days_left: "ditë mbeten",
        overdue: "Ka kaluar",
        total_amount: "Shuma Totale",
        payment_method: "Mënyra e Pagesës",
        created_by: "Krijuar nga",
        user_type: "Lloji Përdoruesit",
        portal_client: "Portal Klienti",
        system_user: "Përdorues Sistemi",
        is_active: "Aktiv",
        change_password: "Ndrysho Fjalëkalimin",
        new_password: "Fjalëkalim i Ri",
    },
    en: {
        login: "Login", logout: "Logout", email: "Email", password: "Password",
        nipt_label: "NIPT (Username)", staff_login: "Staff Login", client_login: "Client Portal",
        login_btn: "Sign In", login_subtitle: "GPS CRM System",
        dashboard: "Dashboard", clients: "Clients", devices: "Devices",
        vehicles: "Vehicles", subscriptions: "Subscriptions", payments: "Payments",
        alerts: "Alerts", users: "Users", settings: "Settings",
        invoices: "Invoices",
        total_clients: "Total Clients", active_devices: "Active Devices",
        unpaid_devices: "Unpaid Devices", monthly_revenue: "Monthly Revenue",
        expiring_soon: "Expiring Soon", recent_payments: "Recent Payments",
        active: "Active", inactive: "Inactive", debtor: "Debtor",
        stock: "Stock", pending: "Pending", expired: "Expired",
        add: "Add", edit: "Edit", delete: "Delete", save: "Save",
        cancel: "Cancel", search: "Search", filter: "Filter",
        transfer: "Transfer", view: "View", generate_pdf: "Generate PDF",
        register_payment: "Register Payment", add_invoice: "Create Invoice",
        client_name: "Client Name", company: "Company",
        phone: "Phone", address: "Address", type: "Type",
        business: "Business", individual: "Individual",
        imei: "IMEI", model: "Model", device_status: "Status",
        client: "Client", no_client: "No Client",
        plate: "License Plate", driver: "Driver", linked_device: "Device",
        plan: "Plan", monthly: "Monthly", yearly: "Yearly",
        start_date: "Start Date", end_date: "End Date", price: "Price",
        amount: "Amount", currency: "Currency", payment_date: "Payment Date",
        method: "Method", cash: "Cash", bank_transfer: "Bank Transfer", card: "Card",
        reference: "Reference", notes: "Notes",
        expiring_subscriptions: "Expiring Subscriptions", expired_subscriptions: "Expired Subscriptions",
        debtor_clients: "Debtor Clients", stock_devices: "Stock Devices",
        no_data: "No data available", loading: "Loading...",
        success: "Success", error: "An error occurred",
        confirm_delete: "Are you sure? This action cannot be undone.",
        invoice_number: "Invoice #", issue_date: "Issue Date", due_date: "Due Date",
        subtotal: "Subtotal", tax: "VAT", total: "Total",
        all_statuses: "All statuses", name: "Name", role: "Role", status: "Status",
        history: "History", transfer_device: "Transfer Device",
        from_client: "From Client", to_client: "To Client", action: "Action",
        date: "Date", assigned: "Assigned", transferred: "Transferred", unassigned: "Unassigned",
        description: "Description", quantity: "Qty", unit_price: "Unit Price",
        auto_renew: "Auto Renew", revenue: "Revenue",
        monthly_chart: "Monthly Revenue (Last 6 months)",
        search_placeholder: "Search by IMEI, name, plate...",
        results_clients: "Clients", results_devices: "Devices", results_vehicles: "Vehicles",
        no_results: "No results found",
        alert_count: "active alerts",
        days_left: "days left",
        overdue: "Overdue",
        total_amount: "Total Amount",
        payment_method: "Payment Method",
        created_by: "Created by",
        user_type: "User Type",
        portal_client: "Client Portal",
        system_user: "System User",
        is_active: "Active",
        change_password: "Change Password",
        new_password: "New Password",
    }
};
